import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-asker',
  templateUrl: './asker.component.html',
  styleUrls: ['./asker.component.css']
})
export class AskerComponent implements OnInit {

  head = ''; ask = ''; 

  constructor(private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.head = data.head;
    this.ask = data.ask;
  }
  ngOnInit(): void {
  }

  close(bool) {
    this.dialogRef.close(bool);
  }

}
